import { Dispatch } from 'redux';
import { ProjectOverview, ProjectTaskOverview, ProjectChangeRequestOverview } from './reducer';
import { removeIrrelevantThreads } from '@/utils/comment-workaround';
import { CommentThreadOverview } from '@/types';

export const setProjectOverview = (dispatch: Dispatch, overview: ProjectOverview) => {
    overview = {
        ...overview,
        comments: removeIrrelevantThreads(overview.comments),
    };

    dispatch({ type: 'SELLER_PROJECT_OVERVIEW_SET', data: overview });
};

export const setProjectOverviewEmpty = (dispatch: Dispatch) => {
    dispatch({ type: 'SELLER_PROJECT_OVERVIEW_CLEAR' });
};

export const setProjectTaskOverview = (dispatch: Dispatch, overview: ProjectTaskOverview) => {
    dispatch({ type: 'SELLER_PROJECT_TASK_OVERVIEW_SET', data: overview });
};

export const setProjectChangeRequestOverview = (dispatch: Dispatch, overview: ProjectChangeRequestOverview) => {
    dispatch({ type: 'SELLER_PROJECT_CR_OVERVIEW_SET', data: overview });
};

export const setProjectCommentsOverview = (dispatch: Dispatch, overview: CommentThreadOverview[]) => {
    dispatch({ type: 'SELLER_PROJECT_COMMENTS_OVERVIEW_SET', data: removeIrrelevantThreads(overview) });
};
